import React from 'react';
import { Box, CssBaseline } from '@mui/material';
import { Outlet, useLocation } from 'react-router-dom';
import Header from '../components/common/Header';
import Footer from '../components/common/Footer';
import InstallButton from '../components/common/InstallButton';

const MainLayout = () => {
  const location = useLocation();
  
  // Check if current path is a dashboard page
  const isDashboardPage = location.pathname.startsWith('/employer') || 
                         location.pathname.startsWith('/jobseeker') ||
                         location.pathname.startsWith('/admin');

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
      }}
    >
      <CssBaseline />
      <Header />
      <Box component="main" sx={{ flexGrow: 1, py: 4, width: '100%' }}>
        <Outlet />
      </Box>
      {!isDashboardPage && <Footer />}
      <InstallButton />
    </Box>
  );
};

export default MainLayout;